export enum ContentTypes {
  Document = 'document',
  Hotspot = 'hotspot',
  ExpandableBlock = 'expandableBlock',
  LinkCuration = 'linkCuration',
  SingleAudio = 'singleAudio',
  VideoInTheLeft = 'videoInTheLeft',
  VideoWithText = 'videoWithText',
  VideoInTheRight = 'videoInTheRight',
  VideoOnTheBottom = 'videoOnTheBottom',
  videoTwoColumns = 'videoTwoColumns',
  SingleVideo = 'singleVideo',
  Checklist = 'checklist',
  ChecklistItem = 'checklistItem',
  ChecklistContent = 'checklistContent',
  HowTo = 'howTo',
  HowToContent = 'howToContent',
  FlipCards = 'flipCards',
  QuoteBlock = 'quoteBlock'
}

export enum ContentDataType {
  TextEditorOneColumn = '[data-type="textEditorOneColumn"]',
  TextEditorWithoutHeading = '[data-type="textEditorWithoutHeading"]',
  TextEditorTwoColumns = '[data-type="textEditorTwoColumns"]',
  TextEditorThreeColumns = '[data-type="textEditorThreeColumns"]',
  ImageEditorOneColumn = '[data-type="imageEditorOneColumn"]',
  ImageEditorTwoColumns = '[data-type="imageEditorTwoColumns"]',
  ImageEditor = '[data-content-type="ImageEditor"]',
  OneImage = '[data-type="oneImage"]',
  ImageOnTheBottom = '[data-type="imageOnTheBottom"]',
  ImageInTheLeft = '[data-type="imageInTheLeft"]',
  ImageInTheRight = '[data-type="imageInTheRight"]',
  VideoInTheLeft = '[data-type="videoInTheLeft"]',
  VideoWithText = '[data-type="videoWithText"]',
  VideoInTheRight = '[data-type="videoInTheRight"]',
  VideoOnTheBottom = '[data-type="videoOnTheBottom"]',
  videoTwoColumns = '[data-type="videoTwoColumns"]',
  SingleVideo = '[data-type="singleVideo"]',
  SingleAudio = '[data-type="singleAudio"]',
  Document = '[data-type="document"]',
  LinkCuration = '[data-type="linkCuration"]',
  Hotspot = '[data-type="hotspot"]',
  HtmlBlock = '[data-type="htmlBlock"]',
  Checklist = '[data-type="checklist"]',
  ChecklistItem = '[data-type="checklistItem"]',
  HowTo = '[data-type="howTo"]',
  HowToContent = '[data-type="howToContent"]',
  FlipCards = '[data-type="flipCards"]',
  ChecklistContent = '[data-type="checklistContent"]',
  ThreeImageLayout = '[data-type="imageEditorThreeColumns"]',
  QuoteBlock = '[data-type="quoteBlock"]'
}
